module.exports = __webpack_public_path__ + "static/icon-tag-31cca76357cdd80ea0aee98d072cb50b.svg";